import { routes } from '@routes';

export const getDesktopHandoff = (continuation: string) => {
  try {
    const url = new URL(continuation, window.location.origin);

    return url.pathname === routes.desktopSignin.make() ? url.searchParams.get('handoff') : null;
  } catch {
    return null;
  }
};
